<template>
  <div class="d-none d-lg-block col-action-bar">
    <div class="sticky-top">
      <div class="bg-white rounded mb-4 p-3 p-sm-4 border-top border-light">
        <h2 class="h4 mb-4">Action</h2>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DesktopActionBar'
}
</script>

<style scoped>
.col-action-bar {
  flex: 0 1 268px;
  max-width: 268px;
}
</style>



// WEBPACK FOOTER //
// src/components/DesktopActionBar.vue